import { inject } from 'aurelia-framework';
import { UserService } from '../Advertiser.SharedPortal/services/user-service';
import { AdvertiserService } from '../Advertiser.SharedPortal/services/advertiser-service';
import { User } from '../models/user';
import { LoggerService } from '../Advertiser.SharedPortal/services/logger-service';
import { StatusService } from '../Advertiser.SharedPortal/services/status-service';
var config = require('../../config.js');

@inject(UserService, LoggerService, StatusService, AdvertiserService)
export class ManageUsers {
    constructor(userService, logger, status, AdvertiserService) {
        this.userService = userService;
        this.logger = logger;
        this.status = status;
        this.advertiserService = AdvertiserService;

        this.user = new User();
        this.submitted = false;
        this.errorMessage = '';
        this.heading = 'Delty Manage Users';
        this.accountManagers = [];
        this.advertisers = [];
        this.selectedAccountManager = {};
        this.selectedAdvertisers = [];
        this.unauthorized = false;
        this.selectAllAdvertisers = false;
        this.myClickCallback = this.clickInput.bind(this);
        this.myKeypressCallback = this.keypressInput.bind(this);
    }

    activate() {
        let that = this;
        if (
            ['spandorf@qw-corp.com', 'tpantig@qw-corp.com', 'kowens@qw-corp.com', 'abroestl@qw-corp.com'].indexOf(
                window.localStorage.getItem('Username')
            ) === -1
        ) {
            this.unauthorized = true;
        }
        this.configStatus();
        this.advertiserService.getAdvertisers().then(function (response) {
            that.advertisers = response.sort((a, b) =>
                a.AdvertiserName.localeCompare(b.AdvertiserName)
            );
        });
        this.userService.getUsers().then(response => {
            response[0].Users.forEach(user => {
                user.Attributes.map(attribute => {
                    if (
                        attribute.Name === 'custom:roles' &&
                        attribute.Value.indexOf('AccountManager') !== -1
                    ) {
                        this.accountManagers.push(user);
                    }
                });
            });
            this.status.dirty();
        });
        window.addEventListener('keypress', this.myKeypressCallback, false);
        window.addEventListener('click', this.myClickCallback, false);
    }

    deactivate() {
        window.removeEventListener('keypress', this.myKeypressCallback);
        window.removeEventListener('click', this.myClickCallback);
    }

    keypressInput(e) {
        if (e.key === 'Enter') {
            this.onSubmit();
        }
    }

    configStatus() {
        // statuses:  dontchange, clean, dirty, working, loading, saving, success, error
        this.status.texts = ['', 'Update User', 'Update User', 'Working', '', '', 'Done', 'Error'];
        this.status.classes = [
            '',
            'btn-disabled',
            'btn-enabled',
            'btn-processing',
            '',
            '',
            'btn-success',
            'btn-error'
        ];
        this.status.clean();
    }

    onSubmit() {
        this.logger.debug('onSubmit() called');
        let that = this;

        if (this.selectedAdvertisers.length > 0) {
            this.AdvertiserKeys = [];
            this.selectedAdvertisers.map(advertiser => {
                this.AdvertiserKeys.push(advertiser.AdvertiserKey);
            });
        } else {
            this.errorMessage = 'Account Managers must have at least 1 Assigned Advertiser';
            return;
        }

        this.userService
            .updateAccountManagerAdvertisers(
                this.selectedAccountManager.Username,
                this.AdvertiserKeys
            )
            .then(response => {
                if (response && response[0] !== 'Success') {
                    this.errorMessage = response;
                    this.submitted = false;
                    this.status.set(
                        this.status.statuses.error,
                        this.status.statuses.done,
                        config.buttonReset
                    );
                } else {
                    this.errorMessage = '';
                    this.status.set(
                        this.status.statuses.success,
                        this.status.statuses.dirty,
                        config.buttonReset
                    );
                    setTimeout(function () {
                        that.submitted = true;
                    }, 1500);
                }
            });
    }

    toggleAllAdvertisers() {
        var toggle = this.selectAllAdvertisers ? false : true;
        this.advertisers.map(advertiser => {
            advertiser.active = toggle;
        });
        this.selectAllAdvertisers = toggle;
    }

    onSelectAssignedAdvertisers() {
        this.setSelectedAdvertisers();
    }

    setSelectedAdvertisers() {
        this.selectedAdvertisers = [];
        this.advertisers.forEach(advertiser => {
            if (advertiser.active) {
                this.selectedAdvertisers.push(advertiser);
            }
        });
    }

    deactivateAdvertiser(advertiser) {
        advertiser.active = false;
        this.setSelectedAdvertisers();
    }

    AccountManagerChanged(accountManager) {
        this.selectAllAdvertisers = false;
        if (accountManager.Username) {
            this.userService
                .getAccountManagerAdvertisers(accountManager.Username)
                .then(response => {
                    var assignedAdvertisers = response[0].AdvertiserKeys;
                    this.selectedAdvertisers = [];
                    this.advertisers.map(advertiser => {
                        if (
                            assignedAdvertisers &&
                            assignedAdvertisers.indexOf(advertiser.AdvertiserKey) !== -1
                        ) {
                            advertiser.active = true;
                            this.selectedAdvertisers.push(advertiser);
                        } else {
                            advertiser.active = false;
                        }
                    });
                });
        }
    }

    clickInput(e) {
        if (e.target.className.indexOf('select-advertisers') == -1) {
            this.showAssignedAdvertisersSelect = false;
        } else {
            this.showAssignedAdvertisersSelect = true;
        }
        this.setSelectedAdvertisers();
    }
}
